import xlsxExport from '../../shared/xlsxExport/xlsxExport';
import {
  periodColumnDefinition,
} from '../../shared/columnDefinitions';
import { SheetExportTypes } from '@common/xlsxExport/xlsxExport.constants';
import { bookToTaxDifferencesColumnDefintionsForImport } from '../../shared/columnDefinitions/bookToTaxDifferences';

export default ({
  periodName,
  bookToTaxDifferences,
  hideDecimals,
  negativeMinus,
  shouldDisplayZero,
  environmentSuffix,
}) => {
  const dataWithPeriods = bookToTaxDifferences.map(row => ({
    periodName,
    ...row,
    countryTaxTypes: row.countryTaxTypes.join(','),
    connections: row.connections.join(','),
    businessUnits: row.businessUnits.join(','),
    excludedCompanyCodes: row.excludedCompanyCodes.join(','),
  }));

  const sheetData = [
    {
      name: 'Book To Tax Differences',
      type: SheetExportTypes.GRID,
      columnDefinitions: [
        periodColumnDefinition,
        ...bookToTaxDifferencesColumnDefintionsForImport,
      ],
      data: dataWithPeriods,
      options: {
        hideDecimals,
        negativeMinus,
        shouldDisplayZero,
      },
    },
  ];

  xlsxExport({
    sheetData,
    metadata: {
      fileName: `TLS_Book_To_Tax_Differences_${periodName}${environmentSuffix}`,
      disableHeaderRendering: true,
    },
  });
};
